import { AxiosRequestConfig } from 'axios';

import { useAuthStore, useCookiesStore } from '../stores/storeRoot';

export class ApiClientBase {
  AppInsightsUserIdHeaderName = 'CC-AI-User';
  AppInsightsSessionIdHeaderName = 'CC-AI-Session';
  MainAbortController = new AbortController();

  public abortRunningRequests(reason?: string) {
    this.MainAbortController.abort(reason);
    this.MainAbortController = new AbortController();
  }

  public async transformOptions(
    options: AxiosRequestConfig,
    requiresAuth: boolean
  ): Promise<AxiosRequestConfig> {
    const controller = this.MainAbortController;
    options.headers = options.headers ?? {};
    console.debug(`ApiClientBase: Configuring ${options.url} request options`);
    if (requiresAuth) {
      if (useAuthStore.getState().navigatedUnauthenticated) {
        console.warn(
          `User is visiting page anonymously. No request should be invoked at the moment!`
        );
      }
      await this.AddTokenToHeaderOrAbortRequest(options, controller);
    }
    this.setTrackingHeadersIfAllowed(options);
    console.debug(`ApiClientBase: ${options.url} configuration completed`);
    return Promise.resolve({
      ...options,
      signal: controller.signal,
    });
  }

  private async AddTokenToHeaderOrAbortRequest(
    options: AxiosRequestConfig,
    controller: AbortController
  ) {
    try {
      console.debug(`ApiClientBase: ${options.url} will receive auth header`);
      const token = await useAuthStore.getState().getAuthToken();
      console.debug(`Token request finished`);
      if (token) {
        options.headers!.Authorization = `Bearer ${token}`;
      } else {
        console.debug(`Failed getting token, will abort the request`);
        controller.abort(`Failed getting token, will abort the request`);
      }
    } catch (e) {
      console.error(e);
      console.debug(`Token request failed. Exception was thrown.`);
      controller.abort(
        `Token request failed. Exception was thrown. will abort the request`
      );
    }
  }

  private setTrackingHeadersIfAllowed(options: AxiosRequestConfig): void {
    console.debug(`ApiClientBase: ${options.url} setting ai headers`);
    if (useCookiesStore.getState().aiUserId()) {
      options.headers![this.AppInsightsUserIdHeaderName] = useCookiesStore
        .getState()
        .aiUserId();
    }
    if (useCookiesStore.getState().aiSessionId()) {
      options.headers![this.AppInsightsSessionIdHeaderName] = useCookiesStore
        .getState()
        .aiSessionId();
    }
  }
}
